import { useEffect, useState } from "react";
import addicon from '../images/additem.png';
import img1 from '../images/subscriptioicon.png';
import axios from "axios";
import deleteIcon from '../images/deleteicon.png';
import disableIcon from '../images/disableicon.png';
import editIcon from '../images/editicon.png';
import viewIcon from '../images/viewicon.png';
import sortIcon from '../images/arrow.png';
import loadIcon from  '../images/loader2.webp';
import img11 from '../images/agreement.png';
import { data } from "react-router";
import Select from "react-select";
import excel from '../images/excelicon.png';
import { exportArrayToExcel } from "../common/mylib";
const Memberships=()=>
{
    const [show,setShow]=useState(false);
    const [msg,setMsg]=useState("");
    const [subscriberdata,setSubscriberData]=useState([]);    
    const [edit,setEdit]=useState(false);
    const [editdata,setEditData]=useState({});

    const [plans,setPlans]=useState([]);
    const [customers,setCustomers]=useState([]);    
    const [facility,setFacility]=useState([]);

    const [dataToDisplay,setDataToDisplay]=useState([]);
    const [pageData,setPageData]=useState([]);
    const [formData,setFormData]=useState({subscriberid:0,facilityid:0,planid:0,orderdate:new Date().toISOString().split("T")[0],startdate:new Date().toISOString().split("T")[0],enddate:new Date(new Date().setMonth(new Date().getMonth() + 11)).toISOString().split('T')[0],isgstbill:"N",planamt:0,discount:0,total:0,security:0,paymentdetails:""});
    const [sortOrder,setsortOrder]=useState(1);
    const [page,setPage]=useState(1);
    const [pageSize,setPageSize]=useState(15);
    const [totalPage,setTotalPage]=useState(0);
    const [progress,setProgress]=useState(false);
    const apiClient = axios.create({
                baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer '+localStorage.getItem("token")
                }
            });  
    const columns = [       
        { name: "Facility", key: "facility", sortable: true},
        { name: "Plan", key: "planname", sortable: true },
        { name: "Customer", key: "subscribername", sortable: true },        
        { name: "Company", key: "subscribercompany", sortable: true },        
        { name: "Start Date", key: "startdate", sortable: true},
        { name: "End Date", key: "enddate", sortable: true},
        { name: "GST Billing", key: "isgstbill", sortable: true},
        { name: "Amount", key: "amount", sortable: true},                              
    ];
    function addSubsriber(event)
    {
        setFormData({subscriberid:0,facilityid:0,planid:0,orderdate:new Date().toISOString().split("T")[0],startdate:new Date().toISOString().split("T")[0],enddate:new Date(new Date().setMonth(new Date().getMonth() + 11)).toISOString().split('T')[0],isgstbill:"N",planamt:0,discount:0,total:0,security:0,paymentdetails:""});
        setPlans([]);        
        setShow(true);
        setMsg("");
    }
    async function saveData(event)
    {
        setMsg("");        
        if(formData.facilityid=="0")
        {
            setMsg("Select Facility!!");
            return;
        }
        if(formData.subscriberid==0)
        {
            setMsg("Customer is Missing!!");
            return;
        }
        if(formData.planid==0)
        {
            setMsg("Select Plan!!");
            return;
        }
        if(new Date(formData.startdate)>=new Date(formData.enddate))
        {
            setMsg("Check Start Date and End Date!!!");
            return;
        }                
        if(parseInt(formData.security)<0)
        {
            setMsg("Invalid Security Amount!!!");
            return;
        } 
        if(window.confirm('Are you sure?'))        
        {
            
            setProgress(true);
            //console.log("Token:",localStorage.getItem("token"));
            //console.log(formData);
            let url="/api/Subscription/CreateSubscription";                        
            await apiClient.post(url,formData).then(reply=>
                {
                if(reply.status==200)
                {
                    if(reply.data.status=="Error")
                    {
                        setMsg(reply.data.message);                        
                    }
                    else if(reply.data.status=="OK")
                    {
                        alert("Data Saved Successfully");
                        loadSubscribers();                        
                        setFormData({subscriberid:0,facilityid:0,planid:0,orderdate:new Date().toISOString().split("T")[0],startdate:new Date().toISOString().split("T")[0],enddate:new Date(new Date().setMonth(new Date().getMonth() + 11)).toISOString().split('T')[0],isgstbill:"N",planamt:0,discount:0,total:0,security:0,paymentdetails:""});
                        setPlans([]);        
                        setShow(false);                        
                    }
                    else
                    {
                        setMsg("Unknown Error!!!");                        
                    }
                }
                });   
            setProgress(false);
        }
        
    }
    async function updateData(event)
    {
        setMsg("");        
        if(editdata.facilityid=="0")
        {
            setMsg("Select Facility!!");
            return;
        }
        if(editdata.subscriberid==0)
        {
            setMsg("Customer is Missing!!");
            return;
        }
        if(editdata.planid==0)
        {
            setMsg("Select Plan!!");
            return;
        }
        if(new Date(editdata.startdate)>=new Date(editdata.enddate))
        {
            setMsg("Check Start Date and End Date!!!");
            return;
        }                         
        if(window.confirm('Are you sure?'))        
        {
            setProgress(true);
            let url="/api/Subscription/UpdateSubscription/"+editdata.id;  
            await apiClient.post(url,editdata).then(reply=>
                {
                if(reply.status==200)
                {
                    if(reply.data.status=="Error")
                    {
                        setMsg(reply.data.message);                        
                    }
                    else if(reply.data.status=="OK")
                    {
                        loadSubscribers();
                        alert("Data Updated Successfully");
                        setEditData({});
                        setPlans([]);        
                        setEdit(false);                        
                    }
                    else
                    {
                        setMsg("Unknown Error!!!");                        
                    }
                }
                }); 
            setProgress(false);  
        }       
    }
    async function loadSubscribers()
    {
        //console.log(localStorage.getItem("token"));
        setProgress(true);
        await apiClient.get("/api/Subscription/GetAllSubscriptions").then(res=>
        {
            if(res.status==200)
            {
                setSubscriberData(res.data.data);
                setDataToDisplay(res.data.data);
                setPageData(res.data.data.slice(0,pageSize));                
                setTotalPage(Math.ceil(res.data.data.length/pageSize));                  
            }
        });
        await apiClient.get("/api/Facilities/GetAll").then(res=>
        {
            if(res.status==200 && res.data.status=="OK")
            {
                setFacility(res.data.data);                      
            }
        });  
        await apiClient.get("/api/Subscription/GetAllSubscribers").then(res=>
        {
            if(res.status==200 && res.data.status=="OK")
            {
                let arr=Array.from(new Map(res.data.data.map(item => [item.id, item])).values());
                arr.sort((e1,e2)=>e1.sname.toLowerCase()>e2.sname.toLowerCase()?1:-1);
                setCustomers(arr);                      
            }
        });     
        //console.log("Token:"+localStorage.getItem("token"));
        setProgress(false);   
    }
    function searchData(event)
    {
        if(event.target.id=="searchText")
        {
            if(event.target.value.length>3)
            {
                let searchResult=subscriberdata.filter((e)=>e.subscribercompany.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.subscribername.toLowerCase().indexOf(event.target.value.toLowerCase())>=0  || e.planname.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 );
                setDataToDisplay(searchResult);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay(subscriberdata);                
                setPageData(subscriberdata.slice(0,pageSize));
            }
            setPage(1);
        }
        if(event.target.id=="searchFacility")
        {
            if(event.target.value!="Facility")
            {
                let searchResult=subscriberdata.filter((e)=>e.facility==event.target.value);
                setDataToDisplay([...searchResult]);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay([...subscriberdata]);
                setPageData(subscriberdata.slice(0,pageSize));
            }
            setPage(1);
        }               
    }
    async function formValueChanged(event)
    {
        if(event.target.id=="facilityid")
        {
            setFormData({...formData,facilityid:event.target.value});
            //console.log("token",localStorage.getItem("token"));
            //console.log("URL:",process.env.REACT_APP_APIURL+"/api/Plan/GetAllPlansByFacility/"+event.target.value);
            await apiClient.get("/api/Plan/GetAllPlansByFacility/"+event.target.value).then(reply=>
            {
                if(reply.status==200 && reply.data.status=="OK")
                {
                    setPlans(reply.data.data);
                }
            });
        } 
        if(event.target.id=="planid" && event.target.value!="0")
        {
            let plan=plans.find(p=>p.planid==event.target.value);
            setFormData({...formData,planid:plan.planid,planamt:plan.amount,discount:0,total:plan.amount});            
        }
        
        if(event.target.id=="orderdate") setFormData({...formData,orderdate:event.target.value});
        if(event.target.id=="startdate") setFormData({...formData,startdate:event.target.value});
        if(event.target.id=="enddate") setFormData({...formData,enddate:event.target.value});

        
        if(event.target.id=="planamt")
        {
            setFormData({...formData,planamt:event.target.value,total:parseInt(event.target.value)-parseInt(formData.discount)});        
        }
        if(event.target.id=="isgstbill")
        {
            setFormData({...formData,isgstbill:event.target.checked?"Y":"N"});        
        }
        if(event.target.id=="discount")
        {
            setFormData({...formData,discount:event.target.value,total:parseInt(formData.planamt)-parseInt(event.target.value)});             
        }        
        if(event.target.id=="security") setFormData({...formData,security:event.target.value});
        if(event.target.id=="paymentdetails") setFormData({...formData,paymentdetails:event.target.value});

        //-----------------------------------------------------------------------------
        
        if(event.target.id=="efacilityid")
        {
            setEditData({...editdata,facilityid:event.target.value});
            await apiClient.get("/api/Plan/GetAllPlansByFacility/"+event.target.value).then(reply=>
            {
                if(reply.status==200 && reply.data.status=="OK")
                {
                    setPlans(reply.data.data);
                }
            });
        }        
        if(event.target.id=="eplanid" && event.target.value!="0")
        {
            let plan=plans.find(p=>p.planid==event.target.value);
            setEditData({...editdata,planid:plan.planid,planamt:plan.amount,discount:0,total:plan.amount});            
        }
        if(event.target.id=="eorderdate") setEditData({...editdata,orderdate:event.target.value});
        if(event.target.id=="estartdate") setEditData({...editdata,startdate:event.target.value});
        if(event.target.id=="eenddate") setEditData({...editdata,enddate:event.target.value});

        if(event.target.id=="eisgstbill")
        {
            setEditData({...editdata,isgstbill:event.target.checked?"Y":"N"});        
        }
        if(event.target.id=="ediscount")
        {
            setEditData({...editdata,discount:event.target.value,total:parseInt(editdata.planamount)-parseInt(event.target.value)});             
        }        
        if(event.target.id=="esecurity") setEditData({...editdata,security:event.target.value});
        if(event.target.id=="edetails") setEditData({...editdata,paymentdetails:event.target.value});
    }
    function deleteCustomer(id)
    {
        if(window.confirm('Would you like to delete it?\nAre you sure?'))
        {
            apiClient.post(process.env.REACT_APP_APIURL+"/api/Subscription/DeleteSubscription/"+id).then(res=>
            {
                if(res.status==200)
                {
                    alert(res.data.message);
                    loadSubscribers();                    
                }
            });
        }
    }
    function disableSubscription(id)
    {
        if(window.confirm('Would you like to Disable this Subscription?\nAre you sure?'))
        {
            apiClient.post(process.env.REACT_APP_APIURL+"/api/Subscription/DisableSubscription/"+id).then(res=>
            {
                if(res.status==200)
                {
                    alert(res.data.message);
                    loadSubscribers();                    
                }
            });
        }
    }    
    function downloadAgreement(id,isgst)    
    {
        if(isgst=="Y")
        {
            window.open(process.env.REACT_APP_APIURL+"/api/DownloadDocument/downloadgstagreement/"+id,"_self");
        }
        else
        {
            window.open(process.env.REACT_APP_APIURL+"/api/DownloadDocument/downloadnongstagreement/"+id,"_self");
        }
    }
    async function editCustomer(id)
    {
        //console.log("Token:"+localStorage.getItem("token"));
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/Subscription/GetSubscriptionById/"+id).then(async (res)=>
        {
            if(res.status==200 && res.data.status=="OK")
            {
                await apiClient.get("/api/Plan/GetAllPlansByFacility/"+res.data.data.facilityid).then(reply=>
                {
                    if(reply.status==200 && reply.data.status=="OK")
                    {
                        setPlans(reply.data.data);
                    }
                });
                setEditData({...res.data.data,orderdate:res.data.data.orderdate.split("-").reverse().join("-"),startdate:res.data.data.startdate.split("-").reverse().join("-"),enddate:res.data.data.enddate.split("-").reverse().join("-"),planamt:res.data.data.planamount,total:res.data.data.amount,discount:res.data.data.discount,security:0,paymentdetails:""});
                setEdit(true);
            }
        });
    }
    function sortData(colname)
    {
        if(colname=="subscribercompany" || colname=="subscribername" || colname=="facility" || colname=="planname" || colname=="isgstbill")
        {
            let arr=[...dataToDisplay];
            arr.sort((e1,e2)=>
            {
                let x=e1[colname].trim().toLowerCase()>e2[colname].trim().toLowerCase()?1:-1;
                x=x*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            }
            );                                    
            setDataToDisplay(arr);                        
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }
        if(colname=="startdate" || colname=="enddate")
        {
            let arr=[...subscriberdata];
            arr.sort((e1,e2)=>
            {
                let d1=new Date(e1[colname]);
                let d2=new Date(e2[colname]);
                let x=(d1-d2)*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            });
            setDataToDisplay([...arr]);
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }
        if(colname=="amount")
        {
            let arr=[...subscriberdata];
            arr.sort((e1,e2)=>
            {
                let d1=isNaN(parseFloat(e1[colname]))?0:parseFloat(e1[colname]);
                let d2=isNaN(parseFloat(e2[colname]))?0:parseFloat(e2[colname]);
                let x=(d1-d2)*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            });
            setDataToDisplay([...arr]);
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }        
    }
    function showPage(pagenumber)
    {
        let adata=dataToDisplay.slice((pagenumber-1)*pageSize,(pagenumber)*pageSize);
        setPageData(adata);
        setPage(pagenumber);
    }
    function showPrev(event)
    {
        let p=page;
        if(page>1) p--;        
        showPage(p);
    }
    function showNext(event)
    {
        let p=page;
        if(page<totalPage) p++;        
        showPage(p);
    }
    useEffect(()=>{
        loadSubscribers();        
    },[]);
    return(
        <div>
            <div className="p-2 d-flex">
                <div className="me-2"><input type="text" id="searchText" style={{fontSize:'12px'}} onChange={searchData} placeholder="Search" className="form-control" /></div>
                <div className="me-2">
                    <select className="form-control" id="searchFacility" onChange={searchData} style={{fontSize:'12px'}}>
                        <option value="Facility">Facility</option>
                        {facility.map((e, idx) => <option key={`fac-${idx}`} value={e.facilityname}>{e.facilityname}</option>)}
                    </select>
                </div>
                <div>                    
                </div>
                <div className="flex-grow-1 text-end"><img src={addicon} style={{width:'30px',cursor:'pointer'}} onClick={addSubsriber} /></div>
                <img onClick={()=>{exportArrayToExcel(dataToDisplay,'Memberships')}} src={excel} style={{width:'30px',marginLeft:'10px',cursor:'pointer'}} />
            </div>
            <div style={{borderRadius:'5px 5px 0px 0px',backgroundColor:'#ffccdd',padding:'5px',fontWeight:'bold'}}>Details of Members</div>            
            <div style={{overflow:"auto",fontSize:'12px'}}>
                <table className="table table-striped table-bordered">
                    <thead>
                        <tr className="table-primary">
                            <th>S.No.</th>
                            {columns.map((e,i)=>                            
                                <th key={`fac-${i}`}>{e.name} {e.sortable?(<img src={sortIcon} onClick={()=>{sortData(e.key)}} style={{width:'10px',cursor:'pointer'}}  alt=""/>):(<></>)}</th>                            
                            )}
                            <th>View/Edit</th>
                            <th>Delete</th>
                            <th>Disable</th>
                            <th>Agreement</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pageData.map((e,i)=>
                            <tr key={`fac-${i}`}>
                                <td>{(page-1)*pageSize+i+1}</td>
                                {columns.map((ee,ii)=>
                                    ee.key=="amount"?(<td key={`fac-${ii}`}>{e[ee.key]}</td>):(<td key={`fac-${ii}`}>{e[ee.key]}</td>)                            
                                )}
                                <td className="text-center"><img onClick={()=>editCustomer(e.id)} src={editIcon} alt="" style={{width:'20px',cursor:'pointer'}} /></td>
                                <td className="text-center"><img onClick={()=>deleteCustomer(e.id)} src={deleteIcon} alt="" style={{width:'20px',cursor:'pointer'}} /></td>
                                <td className="text-center"><img onClick={()=>disableSubscription(e.id)} src={disableIcon} alt="" style={{width:'20px',cursor:'pointer'}} /></td>
                                <td className="text-center"><img onClick={()=>downloadAgreement(e.id,e.isgst)} src={img11} alt="" style={{width:'20px',cursor:'pointer'}} /></td>
                            </tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr className="table-primary">
                            <th colSpan="2"><input type="button" onClick={showPrev} value="<<<" className="btn btn-success btn-sm" /></th>
                            <th colSpan="9" className="text-center"></th>
                            <th colSpan="2" className="text-end"><input type="button" value=">>>" onClick={showNext} className="btn btn-success btn-sm" /></th>
                        </tr>
                        <tr className="table-primary">
                            <th colSpan="13">Total {dataToDisplay.length} Entries</th>                        
                        </tr>
                    </tfoot>
                </table>
            </div>                        
               {show && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md" >
                            <div className="modal-content rounded" style={{border:'double 1px black',backgroundImage:"linear-gradient(#AAF0DE,#BABAFF)", boxShadow:'5px 3px gray'}}>
                                <div className="modal-body p-4">                                    
                                    <div className="text-end"><button className="btn btn-close" onClick={() => setShow(false)}></button></div>
                                    <div className="h5 text-center"><img src={img1} style={{width:'30px',marginRight:'10px'}} />New Subscription</div>
                                    <div className="form-group">
                                        <label>Facility</label>                                            
                                        <select id="facilityid" onChange={formValueChanged} className="form-control">
                                            <option value="0">Select Facility</option>
                                            {facility.map((e,i)=><option key={e.id} value={e.id} selected={formData.facilityid==e.id}>{e.facilityname}</option>)}
                                        </select>
                                    </div>    
                                    <div className="form-group">
                                        <label>Customer</label>
                                        <Select onChange={(option)=>{setFormData({...formData,subscriberid:option.data.id});}} options={customers.map((e,i)=>({value:e.id,label:e.sname+" ["+e.company+"]",data:e}))} placeholder="Search Customers...." isClearable classNamePrefix="react-select"></Select>                                        
                                    </div>
                                    <div className="form-group">
                                        <label>Plan Name</label>
                                        <select id="planid" onChange={formValueChanged}  className="form-control">
                                            <option>Select Plan</option>
                                            {plans.map((e,i)=><option key={"F"+i} value={e.planid} selected={e.planid==formData.planid}>{e.planname}</option>)}
                                        </select>    
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-12">
                                            <label>Order Date</label>
                                            <input id="orderdate" onChange={formValueChanged} value={formData.orderdate}  type="date" className="form-control" />
                                        </div>
                                        <div className="form-group col-6">
                                            <label>Start Date</label>
                                            <input id="startdate" onChange={formValueChanged} value={formData.startdate}  type="date" className="form-control" />
                                        </div>
                                        <div className="form-group col-6">
                                            <label>End Date</label>
                                            <input id="enddate" onChange={formValueChanged} value={formData.enddate} type="date" className="form-control" />
                                        </div>
                                        <div className="form-group col-6">
                                            <label>Plan Amount</label>
                                            <input id="planamt" onChange={formValueChanged} value={formData.planamt} step="0.10"  type="number" className="form-control" />
                                        </div>
                                        <div className="form-group col-6">
                                            <label>Discount</label>
                                            <input id="discount" onChange={formValueChanged}  value={formData.discount} step="0.10" type="number" className="form-control" />
                                        </div>
                                        <div className="form-group col-6">
                                            <label>Amount</label>
                                            <input id="total" onChange={formValueChanged} value={formData.total} step="0.10"  type="number" className="form-control" readOnly />
                                        </div>                                    
                                        <div className="form-group col-6">
                                            <label>Security Amount</label>
                                            <input id="security" onChange={formValueChanged} value={formData.security} step="0.10"  type="number" className="form-control" />
                                        </div>
                                        <div className="form-group col-12">
                                            <label>Payment Details</label>
                                            <input id="paymentdetails" onChange={formValueChanged} value={formData.paymentdetails} type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="mt-2">
                                        Billing : <input type="checkbox" id="isgstbill" onChange={formValueChanged}  /> GST Bill
                                    </div>
                                    <input type="button" className="btn btn-danger mt-2"  onClick={saveData} value="Save Details" /> <span className="text-primary h6 ms-2">{msg}</span>
                                </div>                                
                            </div>
                        </div>
                    </div>
                )}
                {edit && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md" >
                            <div className="modal-content rounded" style={{border:'double 1px black',backgroundImage:"linear-gradient(#AAF0DE,#BABAFF)", boxShadow:'5px 3px gray'}}>
                                <div className="modal-body p-4">                                    
                                    <div className="text-end"><button className="btn btn-close" onClick={() => setEdit(false)}></button></div>
                                    <div className="h5 text-center"><img src={img1} style={{width:'30px',marginRight:'10px'}} />Edit Subscription</div>
                                    <div className="form-group">
                                        <label>Facility</label>                                            
                                        <select id="efacilityid" onChange={formValueChanged} className="form-control">
                                            <option value="0">Select Facility</option>
                                            {facility.map((e,i)=><option key={e.id} value={e.id} selected={editdata.facilityid==e.id}>{e.facilityname}</option>)}
                                        </select>
                                    </div>    
                                    <div className="form-group">
                                        <label>Customer</label>
                                        <input type="text" className="form-control" value={editdata.subscribername+"-"+editdata.subscribercompany} readOnly />
                                    </div>
                                    <div className="form-group">
                                        <label>Plan Name</label>
                                        <select id="eplanid" onChange={formValueChanged}  className="form-control">
                                            <option>Select Plan</option>
                                            {plans.map((e,i)=><option key={"F"+i} value={e.planid} selected={e.planid==editdata.planid}>{e.planname}</option>)}
                                        </select>    
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-12">
                                            <label>Order Date</label>
                                            <input id="eorderdate" onChange={formValueChanged} value={editdata.orderdate}  type="date" className="form-control" />
                                        </div>
                                        <div className="form-group col-6">
                                            <label>Start Date</label>
                                            <input id="estartdate" onChange={formValueChanged} value={editdata.startdate}  type="date" className="form-control" />
                                        </div>
                                        <div className="form-group col-6">
                                            <label>End Date</label>
                                            <input id="eenddate" onChange={formValueChanged} value={editdata.enddate} type="date" className="form-control" />
                                        </div>
                                        <div className="form-group col-6">
                                            <label>Plan Amount</label>
                                            <input id="eplanamt" onChange={formValueChanged} value={editdata.planamt} step="0.10" type="number" className="form-control" readOnly />
                                        </div>
                                        <div className="form-group col-6">
                                            <label>Discount</label>
                                            <input id="ediscount" onChange={formValueChanged}  value={editdata.discount} step="0.10" type="number" className="form-control" />
                                        </div>
                                        <div className="form-group col-6">
                                            <label>Amount</label>
                                            <input id="etotal" onChange={formValueChanged} value={editdata.total}  step="0.10" type="number" className="form-control" readOnly />
                                        </div> 
                                        <div className="form-group col-6">
                                            <label>Security Amount</label>
                                            <input id="esecurity" onChange={formValueChanged} value={editdata.security} step="0.10"  type="number" className="form-control" />
                                        </div> 
                                        <div className="form-group col-6">
                                            <label>Details</label>
                                            <input id="edetails" onChange={formValueChanged} value={editdata.paymentdetails}  type="text" className="form-control"  />
                                        </div>                                                                            
                                    </div>
                                    <div className="mt-2">
                                        Billing : <input type="checkbox" id="eisgstbill" onChange={formValueChanged} checked={editdata.isgstbill=="Y"}  /> GST Bill
                                    </div>
                                    <input type="button" className="btn btn-danger mt-2"  onClick={updateData} value="Update Details" /> <span className="text-primary h6 ms-2">{msg}</span>
                                </div>                                
                            </div>
                        </div>
                    </div>
                )}
                {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">                                                                                                                                                
                                    <img src={loadIcon} alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>                                                            
                        </div>
                    </div>
                )}
        </div>
    );
}
export default Memberships;